import * as moment from 'moment';
import {Component, OnDestroy} from '@angular/core';
import {environment} from '../environments/environment';
import {Router} from '@angular/router';
import {SbService} from './shared/_services/sb.service';
import {Subject} from 'rxjs';
import {SwUpdate} from '@angular/service-worker';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {

  readonly CONFIRMTYPE_NEWVERSION = 'newversion' + moment().unix();

  introDone = false;

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private sbService: SbService,
    private swUpdate: SwUpdate,
  ) {
    // DEFAULT LOCALE OF MOMENT IS 'EN': UPDATE IT'S DATE FORMATTING
    moment.locale('en');
    moment.updateLocale('en', {
      longDateFormat: {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'YYYY-MM-DD',
        l: 'YYYY-M-D',
        LL: 'MMMM Do YYYY',
        ll: 'MMM D YYYY',
        LLL: 'MMMM Do YYYY LT',
        lll: 'MMM D YYYY LT',
        LLLL: 'dddd, MMMM Do YYYY LT',
        llll: 'ddd, MMM D YYYY LT'
      }
    });
    // SUBSCRIBE TO NEW VERSION AVAILABLE
    this.getNewVersion();
    this.getConfirm();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  // ********************************************************************************************************
  // LOAD DATA
  // ********************************************************************************************************

  private getNewVersion(): void {
    // LISTEN FOR NEW VERSIONS
    if (environment.withSw) {
      this.subscribeToNewVersion();
    }
  }

  private subscribeToNewVersion(): void {
    this.swUpdate.available.subscribe(
      () => {
        this.sbService.confirm('New version available', 'I want it', this.CONFIRMTYPE_NEWVERSION);
      }
    );
  }

  private getConfirm(): void {
    // LISTENING TO CONFIRM EVENTS FROM FEEDBACK SERVICE (TO LOAD NEW VERSION)
    this.sbService.onNewConfirm()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (res) => {
          if (res && res === this.CONFIRMTYPE_NEWVERSION) {
            window.location.reload();
          }
        }
      );
  }

  // ********************************************************************************************************
  // UI
  // ********************************************************************************************************

  onIntroDone(e: boolean): void {
    this.introDone = e;
  }

}
